import {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from '@app/i18n';

const LOCALE_LABEL_KEYS: Record<SupportedLocale, string> = {
  en: 'languageEnglish',
  'fr-CA': 'languageFrenchCanadian',
};

export { DEFAULT_LOCALE };
export type LocaleValue = SupportedLocale;

export const LOCALE_OPTIONS = SUPPORTED_LOCALES.map((value) => ({
  value,
  labelKey: LOCALE_LABEL_KEYS[value],
})) as readonly { value: LocaleValue; labelKey: string }[];

export function getLocaleOption(
  value: string,
): { value: LocaleValue; labelKey: string } | undefined {
  return LOCALE_OPTIONS.find((o) => o.value === value);
}

export function getEffectiveLocaleValue(
  raw: string | undefined,
  fallback: LocaleValue,
): LocaleValue {
  const option = raw ? getLocaleOption(raw) : undefined;
  return option?.value ?? fallback;
}
